import { render, staticRenderFns } from "./vy1.vue?vue&type=template&id=b0c2769e&scoped=true"
import script from "./vy1.vue?vue&type=script&lang=js"
export * from "./vy1.vue?vue&type=script&lang=js"
import style0 from "./vy1.vue?vue&type=style&index=0&id=b0c2769e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0c2769e",
  null
  
)

export default component.exports